import React, { useEffect, useRef } from 'react'
import HeroSection from './HeroSection'
import HowMinemiWorks from './HowMinemiWorks'
import HomeLoanEMICalculator from './HomeLoanEMICalculator'
import TestimonialSection from './TestimonialSection'
import Faq from './Faq'
import LoanFilterAndSort from './LoanFilterAndSort'
import FinalCta from './FinalCta'

const MainCarLoan = () => {
    const loanFilterRef = useRef(null);
  
    const scrollToFilter = () => {
      if (loanFilterRef.current) {
        loanFilterRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
  
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
  <div>
    <HeroSection scrollToFilter={scrollToFilter}/>
    <HowMinemiWorks scrollToFilter={scrollToFilter}/>
    <div ref={loanFilterRef}>
    <LoanFilterAndSort/>
    </div>
    <HomeLoanEMICalculator  />
    <TestimonialSection  scrollToFilter={scrollToFilter}/>
    <Faq/>
    <FinalCta/>
  </div>
  )
}

export default MainCarLoan